import React, { ReactNode } from 'react';
import { css, Stack } from '@fluentui/react';
import styles from './Message.module.scss';
import 'katex/dist/katex.min.css';

interface MessageContainerProps {
    isUser: boolean;
    children: ReactNode;
}

const MessageContainer: React.FC<MessageContainerProps> = ({ isUser, children }) => {
    return (
        <Stack
            horizontal
            tokens={{ childrenGap: 10 }}
            verticalAlign="center"
            className={css(styles.msgBox, isUser ? styles.userMessage : styles.sysMsgBox)}
        >
            {children}
        </Stack>
    );
};

export default MessageContainer;
